import React from 'react';
import { LogoProps } from '../types';

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  variant = 'full',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-8',
    medium: 'h-12',
    large: 'h-16',
    xlarge: 'h-20'
  };

  const logoSrc = "/nxp_logo.png";

  return (
    <div className={`flex items-center ${className}`}>
      {variant === 'full' ? (
        <div className="flex items-center space-x-3">
          <img
            src={logoSrc}
            alt="NextPangaea Logo"
            className={`${sizeClasses[size]} w-auto object-contain`}
          />
          <span className="font-bold text-gray-900 text-xl">NextPangaea</span>
        </div>
      ) : (
        <img
          src={logoSrc}
          alt="NextPangaea"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      )}
    </div>
  );
};

export default Logo;